export const Loading = () => {
  return <div className="loading">Loading...</div>;
};
